import { Shadow, VStack } from '@genial/components';
import React, { useContext, useMemo } from 'react';

import { FinancialDetailsContext } from '../../context';
import { transformProduct } from '../../utils';
import { EmptyList } from '../EmptyList';
import { ErrorListing } from '../ErrorListing';
import { AssetCard } from '../shared/AssetCard';
import { AssetLoadingCard } from '../shared/AssetLoadingCard';
import { ProductDistributionHeader } from '../shared/ProductDistributionHeader';

import { emptyListProps, marketTypeToMarketId } from './constants';

export const Composition: React.FC = () => {
  const { data, loading, error, refresher } = useContext(FinancialDetailsContext);

  const products = useMemo(() => (data?.assets || []).map(transformProduct), [data]);

  const renderTable = () => {
    if (error) {
      return <ErrorListing handleReload={refresher} />;
    }

    if (loading) {
      return Array.from({ length: 5 }).map((_, index) => (
        <AssetLoadingCard key={index} index={index} />
      ));
    }

    if (!data?.assets?.length) {
      return <EmptyList {...emptyListProps} />;
    }

    return (
      <VStack space="stack.nano">
        {products.map((product) => {
          return (
            <AssetCard
              key={product.marketNameNormalized}
              hasDetails={false}
              product={{
                ...product,
                marketTypeNormalized: marketTypeToMarketId[product.marketTypeNormalized],
              }}
            />
          );
        })}
      </VStack>
    );
  };

  return (
    <Shadow level={1} borderRadius="sm" my="inset.sm" paddingX="inline.xxxs" paddingY="inline.xxs">
      <VStack space="stack.xxs">
        <ProductDistributionHeader
          isLoading={loading}
          totalValue={data?.total.totalNetWorth || 0}
          products={products}
          hasError={!!error}
        />
        {renderTable()}
      </VStack>
    </Shadow>
  );
};
